export const W = 1100
export const H = 620
export const SPHERE_CX = W / 2
// Anchoring the sphere's top edge pins the globe to the top of the stage across zoom levels.
export const SPHERE_TOP_Y = 60
// Radius in viewBox units. The default framing IS the zoomed-out framing, so MIN_SCALE equals
// it: there is nothing sensible to zoom out to, and the button says so by staying disabled
// until you have zoomed in.
export const DEFAULT_SCALE = 540
export const MIN_SCALE = DEFAULT_SCALE
export const MAX_SCALE = 1400
export const DRAG_THRESHOLD_PX = 4
export const ZOOM_STEP = 1.12
// Auto-spin drift, degrees per frame at 60Hz (~2.4 deg/sec).
export const AUTO_SPIN_LAMBDA = 0.04
// Let go of the globe and it waits before drifting again, otherwise it visibly jerks.
export const RESUME_DELAY_MS = 1500
// How long after the last scroll event the globe is allowed to drift again.
export const SCROLL_IDLE_MS = 180
export const ZOOM_EPSILON = 0.001
// lambda -25 puts Europe and western Africa on the meridian facing the camera.
export const INITIAL_ROTATION = { lambda: -25, phi: 0 }
// 89, not 90: float error at exactly 90 leaks slivers of the back hemisphere.
export const CLIP_ANGLE = 89
export const HORIZON_RAD = (88 * Math.PI) / 180

export const STEPS = 5

// Trial's LIGHT_PALETTE, verbatim (world-map-chrome.tsx). These sit outside the Chargeback
// palette; Josef asked for Trial's exact colours, so they are copied rather than approximated.
// Trial ships no dark palette, so the dark column keeps the same light->dark relationships
// (land lightest, sphere mid, page darkest) using our tokens.
export const PALETTE = {
  light: {
    sphereHighlight: "#F4F8FE",
    sphereShadow: "#C9D7E8",
    countryFill: "#F8FBFF",
    countryHoverFill: "rgba(34, 90, 234, 0.12)",
    countryStroke: "#E2E8F0",
    graticuleOpacity: 0.6
  },
  // Mobile's globe sits at a fixed, much shorter height (see Globe.less) than desktop's
  // full-viewport hero, and Trial's pale wash all but disappears at that size - flat, bolder
  // colours (not Trial's gradient) read as water and land at a glance instead. Both gradient
  // stops match so the "gradient" paints as one flat colour without touching the render code.
  mobileLight: {
    sphereHighlight: "#277AEA",
    sphereShadow: "#277AEA",
    countryFill: "#EDF4FF",
    countryHoverFill: "rgba(34, 90, 234, 0.12)",
    countryStroke: "#E2E8F0",
    graticuleOpacity: 0.6
  },
  dark: {
    sphereHighlight: "#27272A", // @Neutral800
    sphereShadow: "#1D1D1D", // @dark50
    countryFill: "#3F3F46", // @Neutral700
    countryHoverFill: "rgba(34, 90, 234, 0.28)",
    // A solid grey border and a 60% grid read as hard wireframe lines on a dark sphere. Both
    // drop to a faint white wash so the continents separate without drawing the mesh.
    countryStroke: "rgba(255, 255, 255, 0.10)", // ~@dark200
    graticuleOpacity: 0.22
  }
}
export const BRAND = "#225AEA" // @bluePrimary

// The five steps are opacities of @bluePrimary over the opaque land, so the choropleth adds no
// colour outside the palette. Dark starts higher: the same blue reads darker on dark land.
export const RAMP = {
  light: [0.18, 0.34, 0.52, 0.74, 1],
  dark: [0.36, 0.52, 0.68, 0.84, 1]
}
